// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hrsata-jobs .option-card[data-v-9b664e12]{border:2px solid #cfd3e6}.hrsata-jobs .option-card.selected[data-v-9b664e12]{border-color:#3cdbc0}", ""]);
// Exports
module.exports = exports;
